const appBaseUrl = process.env.VUE_APP_IMG_PATH;
const imgUrlHost = '//smb.cdn/materialMini';

module.exports = {
  logo: `${imgUrlHost}/brand/sd-logo.svg`,
  intlLogo: `${imgUrlHost}/brand/sd-cloud-logo.svg`,
  imgEmpty: `${imgUrlHost}/brand/sd-empty.png`,
  iconSize: require(`./imgs/icon-size.png`),
  noDataBg: require(`./imgs/ic_empty_fullgeneral.png`),
  noDataBg2: require(`./imgs/empty-bg-2.svg`),
  uploadIcon: require(`./imgs/upload-icon.svg`),
  uploadIconActive: require(`./imgs/upload-icon-active.svg`),
  iconBetaIntl: require(`./imgs/icon-beta-intl.svg`),
  iconBetaCn: require(`./imgs/icon-beta-cn.svg`),
  topoRoot: require(`./imgs/topoRoot.png`),
  wallRender: require(`./imgs/wall-render.gif`),
  systemNoProd: `${imgUrlHost}/brand/no_prod_sd.png`,
  systemNoProdPrivate: require(`./imgs/no_prod_private.png`),
  systemno_prod_img: require(`./imgs/no_prod_img.png`),
  emoji1active: require(`./imgs/emoji-1.svg`),
  emoji2active: require(`./imgs/emoji-2.svg`),
  emoji3active: require(`./imgs/emoji-3.svg`),
  emoji4active: require(`./imgs/emoji-4.svg`),
  emoji5active: require(`./imgs/emoji-5.svg`),
  emoji1: require(`./imgs/emoji-1-gray.svg`),
  emoji2: require(`./imgs/emoji-2-gray.svg`),
  emoji3: require(`./imgs/emoji-3-gray.svg`),
  emoji4: require(`./imgs/emoji-4-gray.svg`),
  emoji5: require(`./imgs/emoji-5-gray.svg`),
  thankFeedback: require(`./imgs/thank-feedback.png`),
  thankFeedback1: require(`./imgs/thank-feedback1.png`),
  iconAiAutoplace: require(`./imgs/icon-ai-autoplace.svg`),
  iconWell: require(`./imgs/well.svg`),
  magnifyFocus: require(`./imgs/focus.png`),
  cutPoint: require(`./imgs/cutPoint.png`),
  noScheme: require(`./imgs/no-scheme.svg`),
  googleMan: require(`./imgs/google-man.svg`),
  autoPlaceType1: require(`./imgs/autoPlace-type-1.svg`),
  autoPlaceType2: require(`./imgs/autoPlace-type-2.svg`),
  iconUpFloor: require(`./imgs/icon-up-floor.svg`),
  // appDownload: require(`./imgs/app-download-survey.png`),
  // appDownloadIntl: require(`./imgs/app-download-survey-intl.png`),
  // appDownloadIcon: require(`./imgs/app-download-icon.png`),
  // appDownloadBg: require(`./imgs/app-download-bg-zh.png`),
  // appDownloadBgIntl: require(`./imgs/app-download-bg-intl.svg`),
  iconWellBord: require(`./imgs/icon-well-bord.svg`),
  iconWellBordV2: require(`./imgs/icon-well-bord-dark.png`),
  iconWellBordV2Active: require(`./imgs/icon-well-bord-dark-active.png`),
  iconWellBordV2Light: require(`./imgs/icon-well-bord-light.png`),
  iconWellBordV2LightActive: require(`./imgs/icon-well-bord-light-active.png`),
  iconUplink: require(`./imgs/icon-uplink.png`),
  devAngleContral: require(`./imgs/vertical-arrow-1.png`),
  errorIcon: require(`./imgs/icon-error.svg`),
  copperLevel: require(`./imgs/icon-copper-level.svg`),
  goldLevel: require(`./imgs/icon-gold-level.svg`),
  silverLevel: require(`./imgs/icon-silver-level.svg`),
  lineTopArrow: require(`./imgs/line-top-arrow.svg`),
  verticalBg: require(`./imgs/vertical-bg.png`),
  verticalCamera: require(`./imgs/vertical-camera.png`),
  verticalAp: require(`./imgs/vertical-ap.png`),
  verticalBackground: require(`./imgs/vertical-background.png`),
  iconDragArrow: require(`./imgs/icon-drag-arrow.png`),
  devAngleTip: require(`./imgs/dev-angle-tip-1.png`),
  iconSkill: require(`./imgs/icon_skill.svg`),
  bgLineridge: require(`./imgs/bg-lineridge.gif`),
  bgTrunking: require(`./imgs/bg-trunking.gif`),
  bgDrawWell: require(`./imgs/bg-draw-well.gif`),
  angle30: require(`./imgs/icon-angle-30-1.png`),
  angle40: require(`./imgs/icon-angle-40-1.png`),
  angle50: require(`./imgs/icon-angle-50-1.png`),
  angle90: require(`./imgs/icon-angle-90-1.png`),
  autoplaceAnimate: require(`./imgs/auto-place-loading.png`),
  iconComputer: require(`./imgs/survey-computer.svg`),
  iconComputerSatisfy: require(`./imgs/survey-computer-satisfy.svg`),
  iconComputerUnsatisfy: require(`./imgs/survey-computer-unsatisfy.svg`),
  iconTip: require(`./imgs/icon-tip.svg`),
  lineAuthor: require(`./imgs/line-author.png`),
  wallThinAuthorFill: require(`./imgs/wall-thin-author-fill.png`),
  wallMiddleAuthorFill: require(`./imgs/wall-middle-author-fill.png`),
  wallThickAuthorFill: require(`./imgs/wall-thick-author-fill.png`),
  wallThinAuthor: require(`./imgs/wall-thin-author.png`),
  wallMiddleAuthor: require(`./imgs/wall-middle-author.png`),
  wallThickAuthor: require(`./imgs/wall-thick-author.png`),
  bridgeAuthor: require(`./imgs/bridge-author.png`),
  bridgeCicleAuthor: require(`./imgs/bridge-author-cicle.png`),
  iconBlackAuthor: require(`./imgs/icon-area-author-black.png`),
  iconWallAuthor: require(`./imgs/icon-wall-author.png`),
  iconPurpleAuthor: require(`./imgs/icon-area-author.png`),
  floorFace: require(`./imgs/floor-face.svg`),
  floorFaceActive: require(`./imgs/floor-face-active.svg`),
  iconMaster: require(`./imgs/icon-master.svg`),
  scopeBgAll: require(`./imgs/scope-bg-all.svg`),
  scopeBgWall: require(`./imgs/scope-bg-wall.svg`),
  wallScopeAuthor: require(`./imgs/wall-scope-author.svg`),
  wallScopeAuthor2: require(`./imgs/icon-scope-author.png`),
  wallScopeAuthorDefault: require(`./imgs/icon-scope-author-default.png`),
  wallCut: require(`./imgs/cut.svg`),
  warrantyCard: require(`./imgs/warranty-card.svg`),
  warrantyCardOrange: require(`./imgs/warranty-card-orange.svg`),
  iconCheckin: require(`./imgs/icon-checkin.svg`),
  iconLogo: `${imgUrlHost}/brand/icon-logo.svg`,
  iconWall: require(`./imgs/icon-wall.svg`),
  iconWire: require(`./imgs/icon-wire.svg`),
  iconAp: require(`./imgs/icon-ap.svg`),
  iconWallActive: require(`./imgs/icon-wall-active.svg`),
  iconWireActive: require(`./imgs/icon-wire-active.svg`),
  iconApActive: require(`./imgs/icon-ap-active.svg`),
  iconStepDot: require(`./imgs/icon-step-dot.svg`),
  leftArrow: require(`./imgs/left-arrow.svg`),
  iconTopo: require(`./imgs/icon-topo.svg`),
  iconTopoActive: require(`./imgs/icon-topo-active.svg`),
  iconSystem: require(`./imgs/icon-system.svg`),
  iconSystemActive: require(`./imgs/icon-system-active.svg`),
  iconSystemThree: require(`./imgs/icon-system-three.svg`),
  iconSystemThreeActive: require(`./imgs/icon-system-three-active.svg`),
  iconSetScale: require(`./imgs/icon-set-scale.png`),
  iconXiding: require(`./imgs/icon-xiding.svg`),
  iconMianban: require(`./imgs/icon-mianban.svg`),
  apGuide1: require(`./imgs/ap-guide-4.svg`),
  apGuide2: require(`./imgs/ap-guide-5.svg`),
  apGuide3: require(`./imgs/ap-guide-6.svg`),
  apGuide4: require(`./imgs/ap-guide-7.svg`),
  iconE: `${imgUrlHost}/brand/icon-e.svg`,
  iconTinyArrow: require(`./imgs/icon-tiny-arrow.svg`),
  iconShowDemo: require(`./imgs/icon-show-demo.svg`),
  iconGateway: require(`./imgs/icon-gateway.svg`),
  iconGateway2: require(`./imgs/iconGateway.svg`),
  iconSwitch: require(`./imgs/icon-switch.svg`),
  iconSwitch12U: require(`./imgs/iconSwitch12U.svg`),
  iconSwitch22U: require(`./imgs/iconSwitch22U.svg`),
  iconSwitch42U: require(`./imgs/iconSwitch42U.svg`),
  icon3dFlag: require(`./imgs/icon-3d-flag.png`),
  icon3dTag: require(`./imgs/icon-3d-tag.svg`),
  roadmap: `${appBaseUrl}/images/bridge/roadmap.png`,
  terrain: `${appBaseUrl}/images/bridge/terrain.png`,
  satellite: `${appBaseUrl}/images/bridge/Satellite.png`,
  guideFour: `${appBaseUrl}/images/bridge/guide-four-bg.png`,
  guideFourImgTitle: `${appBaseUrl}/images/scheme/guide-4-title.svg`,
  guideFourImg: `${appBaseUrl}/images/scheme/guide-auto-area.jpeg`,
  bgAiAutoplace: `${appBaseUrl}/images/scheme/bg-ai-autoplace.svg`,
  bgAiAutoplaceIntl: `${appBaseUrl}/images/scheme/bg-ai-autoplace-intl.svg`,
  guideFourImgIntl: `${appBaseUrl}/images/scheme/guide-4-intl.jpeg`,
  iconSurveyAI: `${appBaseUrl}/images/scheme/icon-survey-AI.svg`,
  schemeFlash: `${appBaseUrl}/images/scheme/pc-flash.svg`,
  sceneGuideTitle: `${appBaseUrl}/images/scheme/scene-guide-title.svg`,
  sceneGuide1: `${appBaseUrl}/images/scheme/scene-guides-1.svg`,
  sceneGuide2: `${appBaseUrl}/images/scheme/scene-guides-22.svg`,
  sceneGuide3: `${appBaseUrl}/images/scheme/scene-guides-3.svg`,
  sceneGuide4: `${appBaseUrl}/images/scheme/scene-guides-4.svg`,
  sceneGuide5: `${appBaseUrl}/images/scheme/scene-guides-25.svg`,
  sceneGuide6: `${appBaseUrl}/images/scheme/scene-guides-6.svg`,
  animateDraw: `${appBaseUrl}/images/scheme/animate-draw-1.png`,
  iconDrawTip: `${appBaseUrl}/images/scheme/draw-tip.png`,
  betaIcon: require(`./imgs/beta.svg`),
  deAfter: require(`./imgs/deAfter.png`),
  deBefore: require(`./imgs/deBefore.png`),
  selectIcon: require(`./imgs/select-icon.png`),
  feedbackBg: require(`./imgs/feedbackBg.png`),
  wallBlHover: require(`./imgs/wall-bl-hover.png`),
  wallBl: require(`./imgs/wall-bl.png`),
  wallCcsbHover: require(`./imgs/wall-ccsb-hover.png`),
  wallCcsb: require(`./imgs/wall-ccsb.png`),
  wallJzztHover: require(`./imgs/wall-jzzt-hover.png`),
  wallJzzt: require(`./imgs/wall-jzzt.png`),
  wallMcHover: require(`./imgs/wall-mc-hover.png`),
  wallMc: require(`./imgs/wall-mc.png`),
  wallQtHover: require(`./imgs/wall-qt-hover.png`),
  wallQt: require(`./imgs/wall-qt.png`),
  wallSngdHover: require(`./imgs/wall-sngd-hover.png`),
  wallSngd: require(`./imgs/wall-sngd.png`),
  defaultAvatar: require(`./imgs/default-avatar.svg`)
};
